import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {

    // 订单信息List
    findOrderList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/manual_reconciliation/findOrder`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    // 银行流水List
    findBankList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/manual_reconciliation/findBank`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 对账
    reconciliation({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`university/findByList`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
